import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RiderService, AppDataService } from 'app/services';
import { DriverDetailComponent } from 'app/components/home/drivers/driver-detail/driver-detail.component';
import { DomSanitizer } from '@angular/platform-browser';

enum MenuTab {
    OrderDetail = 1,
    Customer = 2,
    Timeline = 3,
    Messages = 4
}

@Component({
    selector: 'vehicle-owner-detail',
    templateUrl: './vehicle-owner-detail.component.html',
    styleUrls: ['./vehicle-owner-detail.component.scss',
        '../../../../../../styles/sidebar.scss']
})
export class VehicleOwnerDetailComponent implements OnInit {

    public ownerVehicleDetailData: any;
    public isVisibleImageModal: boolean = false;
    public isPdfFile: boolean = false;
    public imageArray: string[] = [];

    @Input()
    set _ownerVehicleDetailData(value: any) {
        if (value) {
            this.ownerVehicleDetailData = value;
        }
    }

    @Input()
    public driverDetailComponent!: DriverDetailComponent;

    public isVisibleOwnerInfoDetail: boolean = false;
    @Input()
    set _isVisibleOwnerInfoDetail(value: boolean) {
        this.isVisibleOwnerInfoDetail = value;
    }

    @Output() changedVisibleDisplayVehicleOwnerDetailEmit = new EventEmitter<boolean>();
    changedVisibleDisplayOrderDetail(increased: any) {
        this.changedVisibleDisplayVehicleOwnerDetailEmit.emit(increased);
    }
    constructor(public appDataService: AppDataService, private messageService: MessageService,
        private sanitizer: DomSanitizer, private riderService: RiderService) { }

    ngOnInit(): void { }

    public showVisibleImageModal(images: string[], isPdfFile: boolean) {
        this.imageArray = images;
        this.isVisibleImageModal = true;
        this.isPdfFile = isPdfFile;
    }

    isPdf(url: string): Promise<boolean> {
        if (url) {
            const dto = {
                Url: url
            };

            return this.riderService.getContentTypeByImageUrl(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        console.log(data.ErrorMessage);
                        return false;
                    }

                    if (data.ContentType?.toLowerCase().includes('application/pdf')) {
                        return true;
                    } else {
                        return false;
                    }
                })
                .catch(err => {
                    console.log(err);
                    return false;
                });
        }
        return Promise.resolve(false);
    }

    getSafeUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    cancel() {
        this.changedVisibleDisplayOrderDetail(false);
    }
}
